import { useMemo } from "react";
import { useAlert } from "../../contexts/AlertContext";
import { createAlertHelpers } from "../alertBoxes";

export const useAlertHelpers = () => {
  const alertContext = useAlert();

  return useMemo(() => {
    return createAlertHelpers(alertContext);
  }, [alertContext]);
};
